module.exports = require('./helpers/bundle-url').getBundleURL('eR9sC') + "logo-dark.eefe0b7f.svg";